import { IconButton } from "@chakra-ui/react"
import { CPlay } from "../../../../shared/Icons"

const PlayButton = () => {
  return (
    <IconButton
      w={{ base: "14", sm: "18", md: "24" }}
      h={{ base: "14", sm: "18", md: "24" }}
      isRound
      icon={<CPlay w={{ base: "5", sm: "6", md: "8" }} h={{ base: "5", sm: "6", md: "8" }} />}
      aria-label="Start the video"
      cursor="pointer"
      color="white"
      borderColor="white"
      border="1px solid"
      bgColor="rgba(61,61,61,0.5)"
      _hover={{
        "@media (hover: hover) and (pointer: fine)": { bgColor: "rgba(61,61,61,0.8)" },
      }}
      _active={{
        bgColor: "gray.900",
        transform: "scale(1.05)",
      }}
    />
  )
}

export default PlayButton
